import { useEffect, useState } from 'react'
import { Input, Select } from 'antd';
import { useMutation, useQuery } from '@tanstack/react-query';
import { GET_KPI_SETTING, UPDATE_KPI_SETTING } from '../../../../rest-api/queries/settingKPI';
import styles from './kpiSettingStyle.module.css'
import useQueryParams from '../../../../hooks/useQueryParams';
import { message } from "antd"




const KpiSettings = () => {

  const [activKpiTypes, setActiveKpiTypes] = useState<any>()
  const [kpiData, setKpiData] = useState<any>(null)
  const [selectedType, setSelectedType] = useState<any>()

  const { data, refetch } = useQuery(
    ["GET_KPI_SETTING", ],
      GET_KPI_SETTING,
  )
  
  useEffect(() => {
    if(data) {
      setActiveKpiTypes(data)
    }
  }, [data])

   const { mutate: updateInfo } = useMutation(UPDATE_KPI_SETTING, {
    onSuccess: (res) => {
    },
    onError: (err: any) => {
      // query.removeMany(props.name, "id")
      message.error(String(err))
    },
  })

  const handleClick = () => {
    if(selectedType && kpiData) {
      const _data = {...data}
      _data[selectedType] = Number(kpiData)
      updateInfo(_data)
      refetch()
     } else alert('Вы не выбрали тип платежа')
     refetch()
     setSelectedType(null)
     setKpiData('')
   }

  if(!data) {
    return (
      <div>Loading</div>
    )
  }
  
  const options = [
    {
      id:1,
      name: "Нал.",
      value: 'cashKPI'
    },
    {
      id:2,
      name: "пласт.",
      value: 'plasticKPI'
    },
    {
      id:3,
      name: "перечес.",
      value: 'precheslinKPI'
    },
    {
      id:4,
      name: "в долг",
      value: 'debtKPI'
    },
  ]

  return (
    <div style={{margin: '0'}}>
      <div className={styles.items}>
        {options.map((e) => (
          <div key={e.id} className={styles.item}>
            <p className={styles.item_text}>{e.name}</p>
            <div className={styles.item_kpi}>{data[e.value]}</div>
          </div>
        ))}
      </div>
    <Input.Group compact>
      <Select 
      options={options?.map((option) => ({
        label: option.name,
        value: option.value,
      }))}
      style={{width: '50%'}}
      onChange={(val) => {setSelectedType(val)}}
      placeholder="выберите тип KPI"
      value={ selectedType }
      >
      </Select>
      <Input
      required
      type='number' 
      onChange={(e) => setKpiData(e.target.value)}
      value={kpiData}
      placeholder='введите KPI' 
      style={{ width: '50%' }}/>
    </Input.Group>
      <button type='button' className={styles.button} onClick={handleClick} >
        Сохранить
      </button>  
</div>
  )
}

export default KpiSettings